module.exports = __webpack_public_path__ + "img/1698372682842-pirt rudiyono.jpg.51a6c0ff.webp";